import React, { useState, useRef, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Menu from 'components/Menu';
import { FormTitle, HVcGrid, VcEGrid, VcGrid } from 'components/Grid';

import { TableColumn } from 'components/NewTable/type';
import DateOneSePickersTyping from 'components/DatePicker/DateOneSePickersTyping';

import { isType, localeTw, userTypeList } from 'main_consts';
import { Iobject, Ioption } from 'main_type';
import {
  blobDownload,
  getSample,
  postSearch,
  snackBarRsp,
  confirm,
  deleteItem,
  upload,
  postExcel,
  postExcelAndFunctionName,
  postLockerSetting,
  postUnLockerSetting,
  postUpdateEtaDateCyNote,
} from 'main_api';

import { AgGridReact } from 'ag-grid-react';
import { ColDef, GridOptions } from 'ag-grid-community';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import ClearIcon from '@material-ui/icons/Clear';
import RefreshIcon from '@material-ui/icons/Refresh';

import { useSnackbar } from 'notistack';
import { setLoadingRedux } from 'reducers/shareData/action';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import Radio from 'components/Radio';
import Select from 'components/Material/Select';
import DateSePickersTyping from 'components/DatePicker/DateSePickersTyping';
import CheckBox from 'components/Material/Checkbox';
import Input from 'components/Material/Input';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import WarehouseModal from 'components/Modal/WareHouseModal';
import Header from 'components/Header';
import {
  checkboxChange,
  formatDate,
  getDateDayPlus,
  getfindDropDownExpresssNameList,
  getFindDropDownList,
  getWarehouse,
  initWhrehhouse,
  inputChange,
  radioChange,
  selectChange,
} from '../../../main_func';

import { Iresult, Imaster, ICRUDDetail, ICRUD } from './type';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    input: {
      display: 'none',
    },
  })
);
/** 拆櫃預定表維護 */
const DevaningPlanMtn = (): JSX.Element => {
  const classes = useStyles();
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [formError, setFormError] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const apiName = 'devaningPlanMtn';
  const [rowData, setRowData] = useState<Iresult[]>([]);
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [randomValue, setRandomValue] = useState(Math.random());
  const [warehouseName, setWarehouseName] = useState('');

  const [lineNoOptions, setLineNoOptions] = useState<Ioption[]>([]);
  const [expresssNameOptions, setExpresssNameOptions] = useState<Ioption[]>([]);
  const [enableSave, setEnableSave] = useState<boolean>(false);

  const [fileUpload, setFileUpload] = useState('');

  const masterDefaultValue: Imaster = {
    // 貨櫃卸存上傳日期
    startUploadDate: getDateDayPlus(),
    // 貨櫃卸存上傳日期
    endUploadDate: getDateDayPlus(),
    // 到櫃日期(起)
    startDate: getDateDayPlus(),
    // 到櫃日期(迄)
    endDate: getDateDayPlus(),
    // 海關通關號碼(船隻掛號)
    vesselRegNo: '',
    // 快遞業者/承攬業者
    expresssName: '',
    // 線別
    lineNo: '',
    // 通關日期
    declDate: getDateDayPlus(),
    // 貨櫃號碼
    containerNo: '',

    startUploadDateValid: true,
    endUploadDateValid: true,
    startDateValid: true,
    endDateValid: true,
    declDateValid: true,
    timeCheck: '0',
    timeCheckDeclDate: '0',
    warehouse:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : 'TPEE011S',

    pageSize: 100,
  };
  const [master, setMaster] = useState(masterDefaultValue);
  const [random, setRamdom] = useState(Math.random());

  const setExpresssNameList = () => {
    if (locationCode && master.startUploadDate && master.endUploadDate) {
      const list2: Ioption[] = [];
      getfindDropDownExpresssNameList(
        String(master.startUploadDate),
        String(master.endUploadDate),
        locationCode
      ).then((item) => {
        item.forEach((ExpresssNameList) => {
          list2.push({
            value: ExpresssNameList.expresssName as string,
            label: ExpresssNameList.expresssName as string,
          });
        });
        setExpresssNameOptions(list2);
      });
    }
  };
  useEffect(() => {
    setExpresssNameList();
  }, [master.startUploadDate]);
  useEffect(() => {
    setExpresssNameList();
  }, [master.endUploadDate]);
  useEffect(() => {
    setExpresssNameList();
  }, [locationCode]);
  useEffect(() => {
    getFindDropDownList('findDropDownLineNo', {
      warehouse: locationCode,
    }).then((item) => {
      setLineNoOptions(item);
    });
    if (
      userType &&
      !(
        isType(userTypeList.admin, userType) ||
        isType(userTypeList.type1, userType)
      )
    ) {
      setFormError(true);
      enqueueSnackbar(`您無權限使用此功能!`);
    }
    setMaster((prev) => ({
      ...prev,
      declDate: masterDefaultValue.declDate,
      warehouse: masterDefaultValue.warehouse,
    }));
  }, [userType]);

  const gridRef = useRef<any>(undefined);
  const getColumnDefs = (status: boolean): ColDef[] => {
    return [
      {
        checkboxSelection: true,
        lockPosition: true,
        headerName: '項次',
        field: 'itemNo',
        valueGetter: 'node.rowIndex',
        cellClass: 'locked-col',
        suppressNavigable: true,
        maxWidth: 100,
        filter: false,
        sortable: false,
        editable: false,
        valueFormatter: (data) => {
          return data.value + 1;
        },
      },
      {
        headerName: '上傳日期',
        field: 'uploadDate',
        width: 300,
      },
      {
        headerName: '快遞業/承攬業者',
        field: 'expresssName',
        width: 300,
      },
      {
        headerName: '船掛',
        field: 'vesselRegNo',
        width: 300,
      },
      {
        headerName: '主號',
        field: 'mawbNo',
        width: 300,
      },
      {
        headerName: '貨櫃號碼',
        field: 'containerNo',
        width: 150,
      },
      {
        headerName: '封條',
        field: 'sealNo',
        width: 600,
      },
      {
        headerName: '到櫃日期(預計到港日)',
        field: 'etaDate',
        width: 150,
      },
      {
        headerName: '櫃型',
        field: 'containerForm',
        width: 300,
      },
      {
        headerName: '件數',
        field: 'piece',
        width: 300,
        editable: true,
      },
      {
        headerName: '重量',
        field: 'weight',
        width: 300,
        editable: true,
      },
      {
        headerName: '通關日期',
        field: 'declDate',
        width: 300,
        editable: true,
      },
      {
        headerName: '線別',
        field: 'lineNo',
        width: 300,
        editable: true,
      },
      {
        headerName: '通關順序',
        field: 'cclSeq',
        width: 300,
        editable: true,
      },
      {
        headerName: '櫃場註記',
        field: 'cyNote',
        width: 300,
        editable: true,
      },
      {
        headerName: '銷艙比例',
        field: 'mfOffsetNumber',
        width: 300,
        editable: true,
      },
      {
        headerName: '破損(件)',
        field: 'breakageNumber',
        width: 300,
        editable: true,
      },
      {
        headerName: '船名',
        field: 'vesselName',
        width: 300,
      },
      {
        headerName: '處理說明',
        field: 'processDesc',
        minWidth: 250,
        cellStyle: (params) => {
          if (params && params.data.processDesc === '寫檔成功!') {
            return { fontWeight: 'initial', color: 'black' };
          }
          return { fontWeight: 'bold', color: 'red' };
        },
      },
    ];
  };
  const gridOptions = useMemo<GridOptions>(() => {
    const colDefs: ColDef[] = getColumnDefs(false);

    const options: GridOptions = {
      columnDefs: colDefs,
      defaultColDef: {
        flex: 1,
        minWidth: 120,
        filter: true,
        resizable: true,
        sortable: true,
        editable: false,
      },
      frameworkComponents: {},
      components: {},
      tooltipShowDelay: 1,
      headerHeight: 40,
      rowHeight: 40,
      animateRows: true,
      rowSelection: 'multiple',
      suppressRowClickSelection: true,
      multiSortKey: 'ctrl',
      localeText: localeTw,
      pagination: true,
      paginationPageSize: 100,
    };

    return options;
  }, []);

  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();
  };
  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    try {
      dispatch(setLoadingRedux(true));

      const result = await postSearch(apiName, {
        startUploadDate: master.startUploadDate,
        endUploadDate: master.endUploadDate,
        startDate: master.timeCheck === '1' ? master.startDate : '',
        endDate: master.timeCheck === '1' ? master.endDate : '',
        declDate: master.timeCheckDeclDate === '1' ? master.declDate : '',
        vesselRegNo: master.vesselRegNo,
        expresssName: master.expresssName,
        lineNo: master.lineNo,
        containerNo: master.containerNo,
        noDeclDate: master.timeCheckDeclDate === '2' ? 'Y' : '',
        warehouse: master.warehouse,
      });
      if (!snackBarRsp(enqueueSnackbar, result)) {
        dispatch(setLoadingRedux(false));
        return;
      }

      // TODO 確認List名稱
      const { data: dataTemp } = result.data;
      const {
        enableSave: enableSaveTemp,
        devaningPlanMtnUnloadGoodsListDTOs: rowDetailsTemp,
      } =
        (dataTemp as {
          enableSave: boolean;
          devaningPlanMtnUnloadGoodsListDTOs: unknown | unknown[];
        }) || {};
      const data = rowDetailsTemp as Iresult[];
      if (data && (data || []).length > 0) {
        setEnableSave(enableSaveTemp);
        setRowData(data);
        setOpenSearchTable(true);
      } else {
        setOpenSearchTable(false);
      }
      setRandomValue(Math.random());
      dispatch(setLoadingRedux(false));
    } catch (error) {
      dispatch(setLoadingRedux(false));
    }
  };

  const handleSample = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    try {
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      dispatch(setLoadingRedux(true));

      const result = await getSample(apiName, '');

      blobDownload(result, enqueueSnackbar, `拆櫃順序編排表上傳格式範本.xlsx`);
      dispatch(setLoadingRedux(false));
    } catch (error) {
      dispatch(setLoadingRedux(false));
    }
  };

  function isNumber(value: string) {
    const numberPattern = /^\d+(\.\d+)?$/;
    return numberPattern.test(value);
  }
  function isNumberOrEmpty(value: string) {
    return !value || value === '' ? true : isNumber(value);
  }
  const handleConfirm = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    try {
      dispatch(setLoadingRedux(true));
      await gridRef.current.api.stopEditing(false);

      let chkisNaN: string;
      chkisNaN = 'Y';

      const rowDataCRUD: ICRUDDetail[] = [];

      const selectedDatas = gridRef.current.api.getSelectedNodes();
      if (selectedDatas && selectedDatas.length > 0) {
        selectedDatas.forEach((node: any) => {
          const itemDataCRUD: ICRUDDetail = {
            rownum: node.data.rownum,
            uploadDate: node.data.uploadDate,
            expresssName: node.data.expresssName,
            vesselRegNo: node.data.vesselRegNo,
            mawbNo: node.data.mawbNo,
            containerNo: node.data.containerNo,
            etaDate: node.data.etaDate,
            containerForm: node.data.containerForm,
            declDate: node.data.declDate,
            lineNo: node.data.lineNo,
            cclSeq: node.data.cclSeq,
            cyNote: node.data.cyNote,
            mfOffsetNumber: node.data.mfOffsetNumber,
            breakageNumber: node.data.breakageNumber,
            sealNo1: node.data.sealNo1,
            sealNo2: node.data.sealNo2,
            sealNo3: node.data.sealNo3,
            sealNo4: node.data.sealNo4,
            vesselName: node.data.vesselName,
            piece: node.data.piece,
            weight: node.data.weight,
            sealNo: node.data.sealNo,
            warehouse: node.data.warehouse,
          };
          if (
            !isNumberOrEmpty(node.data.piece) ||
            !isNumberOrEmpty(node.data.weight)
          ) {
            enqueueSnackbar('重量件數必需為數字');
            dispatch(setLoadingRedux(false));
            chkisNaN = 'N';
          }
          return rowDataCRUD.push(itemDataCRUD);
        });
      } else {
        dispatch(setLoadingRedux(false));
        enqueueSnackbar('請先選擇資料');
        return;
      }
      if (chkisNaN === 'N') {
        dispatch(setLoadingRedux(false));
        return;
      }
      const DataCRUD: ICRUD = {
        devaningPlanMtnUnloadGoodsListDTOs: rowDataCRUD,
        startUploadDate: master.startUploadDate,
        endUploadDate: master.endUploadDate,
        startDate: master.timeCheck === '1' ? master.startDate : '',
        endDate: master.timeCheck === '1' ? master.endDate : '',
        declDate: master.timeCheckDeclDate === '1' ? master.declDate : '',
        vesselRegNo: master.vesselRegNo,
        expresssName: master.expresssName,
        lineNo: master.lineNo,
        containerNo: master.containerNo,
        noDeclDate: master.timeCheckDeclDate === '2' ? 'Y' : '',
        warehouse: master.warehouse,
      };

      const result = await confirm(apiName, DataCRUD);

      if (!snackBarRsp(enqueueSnackbar, result)) {
        dispatch(setLoadingRedux(false));
        return;
      }
      const { data: dataTemp } = result.data;

      const {
        enableSave: enableSaveTemp,
        devaningPlanMtnUnloadGoodsListDTOs: rowDetailsTemp,
      } =
        (dataTemp as {
          enableSave: boolean;
          devaningPlanMtnUnloadGoodsListDTOs: unknown | unknown[];
        }) || {};
      const data = rowDetailsTemp as Iresult[];

      if ((data || []).length > 0) {
        setEnableSave(enableSaveTemp);

        setRowData(data);
        setOpenSearchTable(true);
      } else {
        setEnableSave(false);
        setOpenSearchTable(false);
      }
      setRandomValue(Math.random());
      dispatch(setLoadingRedux(false));
    } catch (error) {
      dispatch(setLoadingRedux(false));
      enqueueSnackbar(error);
    }
  };

  const handleDeleteItem = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    try {
      dispatch(setLoadingRedux(true));

      await gridRef.current.api.stopEditing(false);

      const rowDataCRUD: ICRUDDetail[] = [];

      const selectedDatas = gridRef.current.api.getSelectedNodes();
      if (selectedDatas && selectedDatas.length > 0) {
        selectedDatas.forEach((node: any) => {
          const itemDataCRUD: ICRUDDetail = {
            rownum: node.data.rownum,
            uploadDate: node.data.uploadDate,
            expresssName: node.data.expresssName,
            vesselRegNo: node.data.vesselRegNo,
            mawbNo: node.data.mawbNo,
            containerNo: node.data.containerNo,
            etaDate: node.data.etaDate,
            containerForm: node.data.containerForm,
            declDate: node.data.declDate,
            lineNo: node.data.lineNo,
            cclSeq: node.data.cclSeq,
            cyNote: node.data.cyNote,
            mfOffsetNumber: node.data.mfOffsetNumber,
            breakageNumber: node.data.breakageNumber,
            sealNo1: node.data.sealNo1,
            sealNo2: node.data.sealNo2,
            sealNo3: node.data.sealNo3,
            sealNo4: node.data.sealNo4,
            vesselName: node.data.vesselName,
            piece: node.data.piece,
            weight: node.data.weight,
            sealNo: node.data.sealNo,
            warehouse: node.data.warehouse,
          };
          return rowDataCRUD.push(itemDataCRUD);
        });
      } else {
        enqueueSnackbar('請先選擇資料');
        return;
      }

      const DataCRUD: ICRUD = {
        devaningPlanMtnUnloadGoodsListDTOs: rowDataCRUD,
        startUploadDate: master.startUploadDate,
        endUploadDate: master.endUploadDate,
        startDate: master.timeCheck === '1' ? master.startDate : '',
        endDate: master.timeCheck === '1' ? master.endDate : '',
        declDate: master.timeCheckDeclDate === '1' ? master.declDate : '',
        vesselRegNo: master.vesselRegNo,
        expresssName: master.expresssName,
        lineNo: master.lineNo,
        containerNo: master.containerNo,
        noDeclDate: master.timeCheckDeclDate === '2' ? 'Y' : '',
        warehouse: master.warehouse,
      };
      const result = await deleteItem(apiName, DataCRUD);
      dispatch(setLoadingRedux(false));
      if (!snackBarRsp(enqueueSnackbar, result)) {
        return;
      }

      const { data: dataTemp } = result.data;

      const {
        enableSave: enableSaveTemp,
        devaningPlanMtnUnloadGoodsListDTOs: rowDetailsTemp,
      } =
        (dataTemp as {
          enableSave: boolean;
          devaningPlanMtnUnloadGoodsListDTOs: unknown | unknown[];
        }) || {};
      const data = rowDetailsTemp as Iresult[];

      if ((data || []).length > 0) {
        setEnableSave(enableSaveTemp);

        setRowData(data);
        setOpenSearchTable(true);
      } else {
        setEnableSave(false);
        setOpenSearchTable(false);
      }
      setRandomValue(Math.random());
    } catch (error) {
      dispatch(setLoadingRedux(false));
    }
  };

  const handleUpload = async (
    file: string,
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    try {
      dispatch(setLoadingRedux(true));
      await gridRef.current?.api.stopEditing(true);

      // const formData = new FormData();
      // formData.append('execlFile', file);

      // const result = await upload(apiName, formData);

      // postSearch
      // upload

      const result = await upload(apiName, {
        startUploadDate: master.startUploadDate,
        endUploadDate: master.endUploadDate,
        startDate: master.timeCheck === '1' ? master.startDate : '',
        endDate: master.timeCheck === '1' ? master.endDate : '',
        declDate: master.timeCheckDeclDate === '1' ? master.declDate : '',
        vesselRegNo: master.vesselRegNo,
        expresssName: master.expresssName,
        lineNo: master.lineNo,
        containerNo: master.containerNo,
        noDeclDate: master.timeCheckDeclDate === '2' ? 'Y' : '',
        execlFile: file,
        warehouse: master.warehouse,
      });

      if (!snackBarRsp(enqueueSnackbar, result)) {
        dispatch(setLoadingRedux(false));
        return;
      }

      const { data: dataTemp } = result.data;

      const {
        enableSave: enableSaveTemp,
        devaningPlanMtnUnloadGoodsListDTOs: rowDetailsTemp,
      } =
        (dataTemp as {
          enableSave: boolean;
          devaningPlanMtnUnloadGoodsListDTOs: unknown | unknown[];
        }) || {};
      const data = rowDetailsTemp as Iresult[];

      if ((data || []).length > 0) {
        setEnableSave(enableSaveTemp);

        setRowData(data);
        setOpenSearchTable(true);
      } else {
        setEnableSave(false);
        setOpenSearchTable(false);
      }
      setRandomValue(Math.random());
      dispatch(setLoadingRedux(false));
    } catch (error) {
      dispatch(setLoadingRedux(false));
    }
  };
  const selectFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = (e.target as HTMLInputElement).files?.item(0); // 取得選中檔案們的一個檔案

    const reader = new FileReader();
    let fileBase64 = '';
    if (file) {
      setMaster({ ...master, fileName: file.name });
      reader.readAsArrayBuffer(file);
      reader.onloadend = async (evt) => {
        if (evt?.target?.readyState === FileReader.DONE) {
          const arrayBuffer = evt.target.result;
          const array = new Uint8Array(arrayBuffer as ArrayBuffer);
          for (let i = 0; i < array.length; i += 1) {
            fileBase64 += String.fromCharCode(array[i]);
          }
          handleUpload(btoa(fileBase64));
        }
      };
    }
    e.target.value = '';
  };

  const handleDownload = async (e?: React.FormEvent<HTMLFormElement>) => {
    try {
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      dispatch(setLoadingRedux(true));
      await gridRef.current?.api.stopEditing(true);

      const result = await postExcel(apiName, {
        startUploadDate: master.startUploadDate,
        endUploadDate: master.endUploadDate,
        startDate: master.timeCheck === '1' ? master.startDate : '',
        endDate: master.timeCheck === '1' ? master.endDate : '',
        declDate: master.timeCheckDeclDate === '1' ? master.declDate : '',
        vesselRegNo: master.vesselRegNo,
        expresssName: master.expresssName,
        lineNo: master.lineNo,
        containerNo: master.containerNo,
        noDeclDate: master.timeCheckDeclDate === '2' ? 'Y' : '',
        warehouse: master.warehouse,
      });

      blobDownload(
        result,
        enqueueSnackbar,
        `${formatDate(master.startUploadDate, 'yyyyMMdd')}_${formatDate(
          master.endUploadDate,
          'yyyyMMdd'
        )}_${master.warehouse}_拆櫃順序編排表.xlsx`
      );
      dispatch(setLoadingRedux(false));
    } catch (error) {
      dispatch(setLoadingRedux(false));
    }
  };

  const handleLockerSetting = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    try {
      dispatch(setLoadingRedux(true));

      await gridRef.current.api.stopEditing(false);

      const rowDataCRUD: ICRUDDetail[] = [];

      const selectedDatas = gridRef.current.api.getSelectedNodes();
      if (selectedDatas && selectedDatas.length > 0) {
        selectedDatas.forEach((node: any) => {
          const itemDataCRUD: ICRUDDetail = {
            rownum: node.data.rownum,
            uploadDate: node.data.uploadDate,
            expresssName: node.data.expresssName,
            vesselRegNo: node.data.vesselRegNo,
            mawbNo: node.data.mawbNo,
            containerNo: node.data.containerNo,
            etaDate: node.data.etaDate,
            containerForm: node.data.containerForm,
            declDate: node.data.declDate,
            lineNo: node.data.lineNo,
            cclSeq: node.data.cclSeq,
            cyNote: node.data.cyNote,
            mfOffsetNumber: node.data.mfOffsetNumber,
            breakageNumber: node.data.breakageNumber,
            sealNo1: node.data.sealNo1,
            sealNo2: node.data.sealNo2,
            sealNo3: node.data.sealNo3,
            sealNo4: node.data.sealNo4,
            vesselName: node.data.vesselName,
            piece: node.data.piece,
            weight: node.data.weight,
            sealNo: node.data.sealNo,
            warehouse: node.data.warehouse,
          };
          return rowDataCRUD.push(itemDataCRUD);
        });
      } else {
        dispatch(setLoadingRedux(false));
        enqueueSnackbar('請先選擇資料');
        return;
      }
      const DataCRUD: ICRUD = {
        devaningPlanMtnUnloadGoodsListDTOs: rowDataCRUD,
        startUploadDate: master.startUploadDate,
        endUploadDate: master.endUploadDate,
        startDate: master.timeCheck === '1' ? master.startDate : '',
        endDate: master.timeCheck === '1' ? master.endDate : '',
        declDate: master.timeCheckDeclDate === '1' ? master.declDate : '',
        vesselRegNo: master.vesselRegNo,
        expresssName: master.expresssName,
        lineNo: master.lineNo,
        containerNo: master.containerNo,
        noDeclDate: master.timeCheckDeclDate === '2' ? 'Y' : '',
        warehouse: master.warehouse,
      };

      const result = await postLockerSetting(apiName, DataCRUD);

      dispatch(setLoadingRedux(false));
      if (!snackBarRsp(enqueueSnackbar, result)) {
        return;
      }
      const { data: dataTemp } = result.data;

      const {
        enableSave: enableSaveTemp,
        devaningPlanMtnUnloadGoodsListDTOs: rowDetailsTemp,
      } =
        (dataTemp as {
          enableSave: boolean;
          devaningPlanMtnUnloadGoodsListDTOs: unknown | unknown[];
        }) || {};
      const data = rowDetailsTemp as Iresult[];

      if ((data || []).length > 0) {
        setEnableSave(enableSaveTemp);

        setRowData(data);
        setOpenSearchTable(true);
      } else {
        setEnableSave(false);
        setOpenSearchTable(false);
      }
      setRandomValue(Math.random());
    } catch (error) {
      dispatch(setLoadingRedux(false));
    }
  };

  const handleUnLockerSetting = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    try {
      dispatch(setLoadingRedux(true));

      await gridRef.current.api.stopEditing(false);

      const rowDataCRUD: ICRUDDetail[] = [];

      const selectedDatas = gridRef.current.api.getSelectedNodes();
      if (selectedDatas && selectedDatas.length > 0) {
        selectedDatas.forEach((node: any) => {
          const itemDataCRUD: ICRUDDetail = {
            rownum: node.data.rownum,
            uploadDate: node.data.uploadDate,
            expresssName: node.data.expresssName,
            vesselRegNo: node.data.vesselRegNo,
            mawbNo: node.data.mawbNo,
            containerNo: node.data.containerNo,
            etaDate: node.data.etaDate,
            containerForm: node.data.containerForm,
            declDate: node.data.declDate,
            lineNo: node.data.lineNo,
            cclSeq: node.data.cclSeq,
            cyNote: node.data.cyNote,
            mfOffsetNumber: node.data.mfOffsetNumber,
            breakageNumber: node.data.breakageNumber,
            sealNo1: node.data.sealNo1,
            sealNo2: node.data.sealNo2,
            sealNo3: node.data.sealNo3,
            sealNo4: node.data.sealNo4,
            vesselName: node.data.vesselName,
            piece: node.data.piece,
            weight: node.data.weight,
            sealNo: node.data.sealNo,
            warehouse: node.data.warehouse,
          };
          return rowDataCRUD.push(itemDataCRUD);
        });
      } else {
        dispatch(setLoadingRedux(false));
        enqueueSnackbar('請先選擇資料');
        return;
      }
      const DataCRUD: ICRUD = {
        devaningPlanMtnUnloadGoodsListDTOs: rowDataCRUD,
        startUploadDate: master.startUploadDate,
        endUploadDate: master.endUploadDate,
        startDate: master.timeCheck === '1' ? master.startDate : '',
        endDate: master.timeCheck === '1' ? master.endDate : '',
        declDate: master.timeCheckDeclDate === '1' ? master.declDate : '',
        vesselRegNo: master.vesselRegNo,
        expresssName: master.expresssName,
        lineNo: master.lineNo,
        containerNo: master.containerNo,
        noDeclDate: master.timeCheckDeclDate === '2' ? 'Y' : '',
        warehouse: master.warehouse,
      };

      const result = await postUnLockerSetting(apiName, DataCRUD);

      dispatch(setLoadingRedux(false));
      if (!snackBarRsp(enqueueSnackbar, result)) {
        return;
      }
      const { data: dataTemp } = result.data;

      const {
        enableSave: enableSaveTemp,
        devaningPlanMtnUnloadGoodsListDTOs: rowDetailsTemp,
      } =
        (dataTemp as {
          enableSave: boolean;
          devaningPlanMtnUnloadGoodsListDTOs: unknown | unknown[];
        }) || {};
      const data = rowDetailsTemp as Iresult[];

      if ((data || []).length > 0) {
        setEnableSave(enableSaveTemp);

        setRowData(data);
        setOpenSearchTable(true);
      } else {
        setEnableSave(false);
        setOpenSearchTable(false);
      }
      setRandomValue(Math.random());
    } catch (error) {
      dispatch(setLoadingRedux(false));
    }
  };

  const handleUpdateEtaDateCyNote = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    try {
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      dispatch(setLoadingRedux(true));

      await gridRef.current.api.stopEditing(false);

      const rowDataCRUD: ICRUDDetail[] = [];

      const selectedDatas = gridRef.current.api.getSelectedNodes();
      if (selectedDatas && selectedDatas.length > 0) {
        selectedDatas.forEach((node: any) => {
          const itemDataCRUD: ICRUDDetail = {
            rownum: node.data.rownum,
            uploadDate: node.data.uploadDate,
            expresssName: node.data.expresssName,
            vesselRegNo: node.data.vesselRegNo,
            mawbNo: node.data.mawbNo,
            containerNo: node.data.containerNo,
            etaDate: node.data.etaDate,
            containerForm: node.data.containerForm,
            declDate: node.data.declDate,
            lineNo: node.data.lineNo,
            cclSeq: node.data.cclSeq,
            cyNote: node.data.cyNote,
            mfOffsetNumber: node.data.mfOffsetNumber,
            breakageNumber: node.data.breakageNumber,
            sealNo1: node.data.sealNo1,
            sealNo2: node.data.sealNo2,
            sealNo3: node.data.sealNo3,
            sealNo4: node.data.sealNo4,
            vesselName: node.data.vesselName,
            piece: node.data.piece,
            weight: node.data.weight,
            sealNo: node.data.sealNo,
            warehouse: node.data.warehouse,
          };
          return rowDataCRUD.push(itemDataCRUD);
        });
      } else {
        dispatch(setLoadingRedux(false));
        enqueueSnackbar('請先選擇資料');
        return;
      }
      const DataCRUD: ICRUD = {
        devaningPlanMtnUnloadGoodsListDTOs: rowDataCRUD,
        startUploadDate: master.startUploadDate,
        endUploadDate: master.endUploadDate,
        startDate: master.timeCheck === '1' ? master.startDate : '',
        endDate: master.timeCheck === '1' ? master.endDate : '',
        declDate: master.timeCheckDeclDate === '1' ? master.declDate : '',
        vesselRegNo: master.vesselRegNo,
        expresssName: master.expresssName,
        lineNo: master.lineNo,
        containerNo: master.containerNo,
        noDeclDate: master.timeCheckDeclDate === '2' ? 'Y' : '',
        warehouse: master.warehouse,
      };

      const result = await postUpdateEtaDateCyNote(apiName, DataCRUD);

      if (!snackBarRsp(enqueueSnackbar, result)) {
        dispatch(setLoadingRedux(false));
        return;
      }
      const { data: dataTemp } = result.data;

      const {
        enableSave: enableSaveTemp,
        devaningPlanMtnUnloadGoodsListDTOs: rowDetailsTemp,
      } =
        (dataTemp as {
          enableSave: boolean;
          devaningPlanMtnUnloadGoodsListDTOs: unknown | unknown[];
        }) || {};
      const data = rowDetailsTemp as Iresult[];

      if ((data || []).length > 0) {
        setEnableSave(enableSaveTemp);

        setRowData(data);
        setOpenSearchTable(true);
      } else {
        setEnableSave(false);
        setOpenSearchTable(false);
      }
      setRandomValue(Math.random());

      dispatch(setLoadingRedux(false));
    } catch (error) {
      dispatch(setLoadingRedux(false));
    }
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (master.startUploadDate.length === 0) {
      master.startUploadDate = getDateDayPlus();
    }
    if (master.endUploadDate.length === 0) {
      master.endUploadDate = getDateDayPlus();
    }

    if (master.startDate.length === 0) {
      master.startDate = getDateDayPlus();
    }
    if (master.endDate.length === 0) {
      master.endDate = getDateDayPlus();
    }

    if (master.declDate.length === 0) {
      master.declDate = getDateDayPlus();
    }

    if (
      !master.startUploadDateValid ||
      !master.endUploadDateValid ||
      (master.timeCheck === '1' &&
        (!master.startDateValid || !master.endDateValid)) ||
      (master.timeCheckDeclDate === '1' && !master.declDateValid)
    ) {
      return;
    }
    switch (submitKey) {
      case 'search':
        handleSearch();
        break;
      case 'confirm':
        handleConfirm();
        break;
      case 'deleteItem':
        handleDeleteItem();
        break;
      case 'getSample':
        handleSample();
        break;
      case 'getExcel':
        handleDownload();
        break;
      case 'lockerSetting':
        handleLockerSetting();
        break;
      case 'unlockerSetting':
        handleUnLockerSetting();
        break;
      case 'updateEtaDateCyNote':
        handleUpdateEtaDateCyNote();
        break;

      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
  };

  const selectPage = async () => {
    // console.log(gridRef.current!.api.paginationGetCurrentPage());
    // gridRef.current!.api.forEachNode((node: any, index: number) =>
    //   node.setSelected(!!node.data && node.data.year !== 2012)
    // );
    // let lastIndex: number;
    // let maxIndex :number;
    if (gridRef.current) {
      const setRangeSelected = async (
        firstIndex: number,
        lastIndex: number
      ) => {
        let index = lastIndex;
        let index2 = lastIndex;
        let index3 = firstIndex;

        const maxIndex: number =
          gridRef.current.api.paginationGetRowCount() as number;
        if (lastIndex > maxIndex) {
          index2 = maxIndex;
        }
        index3 = 0;

        for (index = index3; index < index2; index += 1) {
          const rowNode = gridRef.current.api.getDisplayedRowAtIndex(index);
          if (rowNode) {
            rowNode.setSelected(true, false);
          }
        }
      };
      // 取得當前頁數第一筆
      const firstIdx =
        gridRef.current.api.paginationGetCurrentPage() *
        gridRef.current.api.paginationGetPageSize();
      // 取得當前頁數最後一筆
      const lastIdx: number =
        firstIdx + gridRef.current.api.paginationGetPageSize();
      // 設定範圍選取
      setRangeSelected(firstIdx, lastIdx);
    }
  };

  const selectNoPage = async () => {
    // gridRef.current!.api.forEachNode((node: any, index: number) =>
    //   node.setSelected(!!node.data && node.data.year !== 2012)
    // );
    // let lastIndex: number;
    // let maxIndex :number;
    if (gridRef.current) {
      const setRangeSelected = async (
        firstIndex: number,
        lastIndex: number
      ) => {
        let index = lastIndex;
        let index2 = lastIndex;
        let index3 = firstIndex;

        const maxIndex: number =
          gridRef.current.api.paginationGetRowCount() as number;
        if (lastIndex > maxIndex) {
          index2 = maxIndex;
        }
        index3 = 0;

        for (index = index3; index < index2; index += 1) {
          const rowNode = gridRef.current.api.getDisplayedRowAtIndex(index);
          if (rowNode) {
            rowNode.setSelected(false, false);
          }
        }
      };
      // 取得當前頁數第一筆
      const firstIdx =
        gridRef.current.api.paginationGetCurrentPage() *
        gridRef.current.api.paginationGetPageSize();
      // 取得當前頁數最後一筆
      const lastIdx: number =
        firstIdx + gridRef.current.api.paginationGetPageSize();
      // 設定範圍選取
      setRangeSelected(firstIdx, lastIdx);
    }
  };
  const handleReset = async () => {
    setRamdom(Math.random());
    setMaster(masterDefaultValue);
    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
    setEnableSave(false);
    setExpresssNameList();
  };
  return (
    <div id="page-area">
      <Header />
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 拆櫃預定表維護
          </div>
        </div>
        <div className="input-area">
          {isType(userTypeList.admin, userType) && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>
                  {[...userTypeList.type2, ...userTypeList.type1].indexOf(
                    userType
                  ) !== -1
                    ? '*'
                    : ''}
                  貨棧業者：
                </FormTitle>
              </VcEGrid>
              <VcGrid item xs={12} sm={3}>
                <WarehouseModal
                  value={master.warehouse}
                  updateData={updateData}
                  setStatus={setWarehouseName}
                />
              </VcGrid>

              <VcGrid item xs={12} sm={3}>
                {warehouseName && (
                  <Alert
                    severity="info"
                    style={{
                      width: '100%',
                      color: 'red',
                      margin: '0 0.5rem',
                      fontSize: '1em',
                    }}
                    icon={false}
                  >
                    {warehouseName}
                  </Alert>
                )}
              </VcGrid>
            </Grid>
          )}
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*貨櫃卸存上傳日期：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={5} style={{ maxWidth: 900 }}>
              <DateSePickersTyping
                key={random}
                updateData={updateData}
                style={{ maxWidth: 800 }}
                names={['startUploadDate', 'endUploadDate']}
                data={master}
                seInterval={15}
              />
            </VcGrid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>到櫃日期：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm style={{ maxWidth: 800 }}>
              <DateSePickersTyping
                key={random}
                required={master.timeCheck === '1'}
                disabled={master.timeCheck === '0'}
                updateData={updateData}
                style={{ maxWidth: 800 }}
                names={['startDate', 'endDate']}
                data={master}
                seInterval={31}
              />
            </VcGrid>
            <VcGrid item xs={12} sm={2}>
              <CheckBox
                label="加入到櫃日期查詢"
                checked={master.timeCheck === '1'}
                name="timeCheck"
                onChange={(e) => {
                  setMaster((prev) => ({
                    ...prev,
                    startDate: masterDefaultValue.startDate,
                    startTime: masterDefaultValue.startTime,
                    ...checkboxChange()(['1', '0'])(e),
                  }));
                }}
              />
            </VcGrid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>快遞/承攬業者：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Select
                // placeholder="請先填入分號"
                value={master.expresssName}
                onChange={selectChange(updateData)}
                name="expresssName"
                options={expresssNameOptions}
                // disabled={options.length === 0}
              />
            </Grid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>線別：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Select
                // placeholder="請先填入分號"
                value={master.lineNo}
                onChange={selectChange(updateData)}
                name="lineNo"
                options={lineNoOptions}
                // disabled={options.length === 0}
              />
            </Grid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>通關日期：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={5} style={{ maxWidth: 900 }}>
              <DateOneSePickersTyping
                required={master.timeCheckDeclDate === '1'}
                disabled={
                  master.timeCheckDeclDate === '0' ||
                  master.timeCheckDeclDate === '2'
                }
                updateData={updateData}
                style={{ maxWidth: 200 }}
                inputDataName="declDate"
                data={master}
                seInterval={31}
              />
            </VcGrid>

            <HVcGrid item xs={12} sm={2}>
              <Radio
                className="input-radio "
                required
                name="timeCheckDeclDate"
                value={master.timeCheckDeclDate}
                onChange={radioChange(updateData)}
                options={[
                  { value: '0', label: '不加入查詢條件' },
                  { value: '1', label: '加入通關日期' },
                  { value: '2', label: '無通關日期' },
                ]}
              />
            </HVcGrid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              貨櫃號碼：
            </VcEGrid>
            <Grid item xs={12} sm={2}>
              <Input
                maxLength={35}
                value={master.containerNo}
                name="containerNo"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              船隻掛號：
            </VcEGrid>
            <Grid item xs={12} sm={2}>
              <Input
                maxLength={35}
                value={master.vesselRegNo}
                name="vesselRegNo"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>

          <Grid item xs={12} sm="auto">
            <Button
              disabled={
                userTypeList.type4.some((v) => v === userType) &&
                locationCode.trim().length === 0
              }
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
          <VcEGrid item xs={12} sm="auto">
            <Button
              disabled={!enableSave || formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={() => setSubmitKey('confirm')}
            >
              確定
            </Button>
          </VcEGrid>

          <Grid item xs={12} sm="auto">
            <input
              disabled={formError}
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              className={classes.input}
              id="contained-button-file"
              // multiple
              type="file"
              onChange={selectFile}
            />
            <label htmlFor="contained-button-file">
              <Button
                disabled={formError}
                variant="contained"
                color="default"
                startIcon={<AttachFileIcon />}
                component="span"
                style={{
                  borderRadius: '20px',
                  // backgroundColor: 'blue',
                }}
              >
                上傳EXCEL
              </Button>
            </label>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('getExcel')}
            >
              下載EXCEL
            </Button>
          </Grid>

          <Grid item xs={12} sm="auto">
            <Button
              disabled={!enableSave || formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<SaveIcon />}
              onClick={() => setSubmitKey('lockerSetting')}
            >
              留櫃設定
            </Button>
          </Grid>

          <Grid item xs={12} sm="auto">
            <Button
              disabled={!enableSave || formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<SaveIcon />}
              onClick={() => setSubmitKey('unlockerSetting')}
            >
              取消留櫃
            </Button>
          </Grid>

          <Grid item xs={12} sm="auto">
            <Button
              disabled={!enableSave || formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<SaveIcon />}
              onClick={() => setSubmitKey('updateEtaDateCyNote')}
            >
              取得到櫃日期
            </Button>
          </Grid>
          {/* <Grid item xs={12} sm="auto">
            <Button
              type="submit"
              variant="outlined"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={() => setSubmitKey('getSample')}
            >
              下載EXCEL格式範本
            </Button>
          </Grid> */}
        </Grid>
        <div
          style={{
            color: 'red',
            fontWeight: 800,
            marginLeft: '10%',
            padding: 0,
          }}
        >
          說明：櫃場註記只能輸入20碼
        </div>
      </form>

      {openSearchTable && (
        <Grid container>
          <VcEGrid>
            <Button
              className="button-DutyNoQryDld"
              type="submit"
              onClick={selectPage}
              variant="contained"
              color="default"
              startIcon={
                <DoneAllIcon
                  style={{
                    borderRadius: '30px',
                  }}
                />
              }
            >
              全選
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              className="button-DutyNoQryDld"
              type="submit"
              onClick={selectNoPage}
              variant="contained"
              color="default"
              startIcon={<ClearIcon />}
            >
              全不選
            </Button>
          </Grid>
        </Grid>
      )}
      {openSearchTable && (
        <div className="ag-theme-alpine" style={{ height: '500px' }}>
          <AgGridReact
            ref={gridRef}
            rowData={rowData}
            gridOptions={gridOptions}
            onGridReady={onGridReady}
          />
        </div>
      )}
    </div>
  );
};

export default DevaningPlanMtn;
